
























































import {Component, Vue, Prop} from 'vue-property-decorator';
import {PModuleWithMeasurements, PModuleEvent} from '@/views/system/modules/interfaces';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import {DBRecordsTableHeader} from '@/views/system/modules/interfaces';
import {getFormattedDate} from '@/utils/dateTimeUtils';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {Loading},
})
export default class TableLastDBBoundaryRecords extends Vue {
  // Программный модуль
  @Prop()
  pmodule!: PModuleWithMeasurements;

  // хранилище
  @Prop()
  apiStore!: PModuleStoreModule;

  // Событие
  @Prop()
  event!: PModuleEvent;

  headers: DBRecordsTableHeader[] = [];
  items: any[] = [];

  //Количество последних записей, получаемых с сервера
  limit = 10;

  error = false;
  loading = true;

  newItems: any[] = [];

  async loadData() {
    this.error = false;
    this.loading = true;
    try {
      const records = await this.apiStore.getLastEvents({
        id: this.pmodule?.id as number,
        eventType: this.event?.type,
        limit: this.limit,
      });
      records[1].forEach((header: any) => {
        this.headers.push({text: header[0], value: header[0], sortable: false});
      });

      this.items = records[0].map((values: any[]) => {
        const row: {[key: string]: any} = {};
        values.forEach((v, index) => {
          row[this.headers[index].value] = v;
        });
        return row;
      });

      const index = this.headers.findIndex((header: any) => header.value === 'timestamp');
      if (index !== -1) {
        this.headers.splice(index + 1, 0, {text: 'date', value: 'date', sortable: false});
        this.items = this.items.map((item: any) => {
          return {
            ...item,
            date: getFormattedDate(item.timestamp, 'dd.MM.yyyy HH:mm:ss,SSS'),
          };
        });
      }

      await this.changeTable();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async changeTable() {
    this.headers = this.headers.filter(
      (header: any) => header.text == 'value' || header.text == 'mean' || header.text == 'date',
    );
    this.headers.forEach((x: any) => {
      if (x.text == 'mean' || x.text == 'value') x.text = 'Значение';
      else if (x.text == 'date') x.text = 'Дата';
      else if (x.text == 'action') x.text = 'Событие';
    });

    this.headers.push({sortable: false, text: 'Нижняя граница', value: 'bottom_boundary'});
    this.headers.push({sortable: false, text: 'Верхняя граница', value: 'top_boundary'});
    this.headers.push({sortable: false, text: 'Пояснение', value: 'explanation'});

    // загружаем список типов измерений
    const {data} = await httpClient.get(`/module_type_measurements/`);

    this.items.forEach((item: any) => {
      // создаем массив из границ и сортируем его
      let boundOfItem: any[] = [];
      boundOfItem.push(item.bottom_warning_boundary);
      boundOfItem.push(item.bottom_danger_boundary);
      boundOfItem.push(item.bottom_error_boundary);
      boundOfItem.push(item.top_warning_boundary);
      boundOfItem.push(item.top_danger_boundary);
      boundOfItem.push(item.top_error_boundary);

      const sortedArray = [];
      for (; boundOfItem.length; ) {
        sortedArray.push(boundOfItem.splice(boundOfItem.indexOf(Math.min(...boundOfItem)), 1)[0]);
      }
      boundOfItem = sortedArray;

      // находимо ближайшие к нашему значению границы
      let bottom: any = null;
      let top: any = null;
      const mean = item.mean ? item.mean : item.value;
      boundOfItem.forEach((x: any) => {
        // ищем до тех пор, пока обе границы не заполнятся
        if (x == mean) {
          bottom = x;
          top = x;
        } else if (x < mean) bottom = x;
        else {
          if (!top) top = x;
        }
      });

      // загружаем измерение и формируем пояснение
      const measurement = data.filter((x: any) => x.id == item.boundary_id);
      const meas = measurement[0];

      const res =
        item.action == 0
          ? 'в норме'
          : item.action == 1
          ? 'достигло предупреждающей границы'
          : item.action == 2
          ? 'достигло опасной границы'
          : 'достигло границы недопустимого';

      const exp = 'Значение измерения ' + `"${meas.name}` + '(' + meas.short_name + ')" ' + res;

      const newItem = {
        date: item.date,
        mean: mean,
        action: item.action,
        bottom_boundary: bottom,
        top_boundary: top,
        explanation: exp,
      };

      this.newItems.push(newItem);
    });
  }

  async created() {
    this.loadData();
  }

  reload() {
    this.headers = [];
    this.items = [];
    this.newItems = [];
    this.loadData();
  }
}
